export default __webpack_public_path__ + "static/media/icn_map_pin_missed.ce7230aa.svg";